import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import General_Medications from "../../../components/PatientOnboard/general_Medications";
import MedicalInfo from "../../../components/PatientOnboard/MedicalInfo";
import UpdateFiles from "../../../components/PatientOnboard/UpdateFiles";


class OtherMedicalInfoTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    goBack = () => {
        this.props.goBack()
    }

    addFileObj = (index,selectedCategory,selectedFile) => {
        this.props.addFileObj(index,selectedCategory,selectedFile)
    }
    render() {
        let {t} = this.props

        return (

            <div  className={'patientForm-box-container'}>

                    <FormElementContainer title={t('patient_boarding.Medical_information')}
                                          Component={MedicalInfo}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              goBack:() => this.goBack() ,
                                              entry:this.props.entry,
                                              psychiatric_diagnose_icd:this.props.psychiatric_diagnose_icd,
                                              errors:this.props.errors,
                                              t:(e) => this.props.t(e)

                                          }}/>
                                    {/*      <FormElementContainer title={t('patient_boarding.upload_files')}
                                          Component={UpdateFiles}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              addFileObj:(index,selectedCategory,selectedFile) => this.addFileObj(index,selectedCategory,selectedFile),
                                              goBack:() => this.goBack() ,
                                              entry:this.props.entry,
                                              addedFilesList:this.props.addedFilesList,
                                              errors:this.props.errors,
                                              addedFilesObj:this.props.addedFilesObj,
                                              t:(e) => this.props.t(e)
                                          }}/>*/}

            </div>
        );
    }
}



const OtherMedicalInfoTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(OtherMedicalInfoTabComposed);

export default OtherMedicalInfoTab;

